/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const authUserOutputDataOrganisationHeadcountSchema = z.enum([
	'1-10',
	'11-50',
	'51-200',
	'201-500',
	'501-1000',
	'1000+',
])

export type AuthUserOutputDataOrganisationHeadcountSchema = z.infer<
	typeof authUserOutputDataOrganisationHeadcountSchema
>
